import { localeConfig } from 'shared/domains/languages/config';
import { getCurrentMarket } from 'shared/domains/markets/config';
// marketCode:localeCode
export const links = {
    homepage: {
        'uk:en-gb': '',
        'de:en-gb': '',
        'se:sv': 'sv',
        'se:sv-se': 'sv',
        'se:en-gb': '',
        'no:en-gb': '',
        'no:nb-no': '',
    },
    cookies: {
        'uk:en-gb': 'en-uk/cookies',
        'de:en-gb': 'en-uk/cookies',
        'se:sv': 'sv-se/cookies',
        'se:sv-se': 'sv-se/cookies',
        'se:en-gb': 'sv-se/cookies',
        'no:en-gb': 'nb-no/cookies-norway',
        'no:nb-no': 'nb-no/cookies-norway',
    },
    documents: {
        'uk:en-gb': 'en-uk/contracts-and-documents',
        'de:en-gb': 'en-uk/contracts-and-documents',
        'se:sv': 'sv-se/avtal-och-dokument',
        'se:sv-se': 'sv-se/avtal-och-dokument',
        'se:en-gb': 'sv-se/avtal-och-dokument',
        'no:en-gb': 'nb-no/kontrakter-dokumenter-norge',
        'no:nb-no': 'nb-no/kontrakter-dokumenter-norge',
    },
    about: {
        'uk:en-gb': 'en-uk/how-it-works',
        'de:en-gb': 'en-uk/how-it-works',
        'se:sv': 'sv-se/hur-det-fungerar',
        'se:sv-se': 'sv-se/hur-det-fungerar',
        'se:en-gb': 'sv-se/hur-det-fungerar',
        'no:en-gb': 'nb-no/slik-fungerer-pocketlaw',
        'no:nb-no': 'nb-no/slik-fungerer-pocketlaw',
    },
    extSharingTerms: {
        'uk:en-gb': 'en-uk/external-sharing-terms-of-service',
        'de:en-gb': 'en-uk/external-sharing-terms-of-service',
        'se:sv': 'sv-se/external-sharing-allmana-villkor',
        'se:sv-se': 'sv-se/external-sharing-allmana-villkor',
        'se:en-gb': 'sv-se/external-sharing-allmana-villkor',
        'no:en-gb': 'nb-no/vilkar-og-betingelser-external-sharing',
        'no:nb-no': 'nb-no/vilkar-og-betingelser-external-sharing',
    },
    extSharingPrivacy: {
        'uk:en-gb': 'en-uk/external-sharing-privacy-policy',
        'de:en-gb': 'en-uk/external-sharing-privacy-policy',
        'se:sv': 'sv-se/external-sharing-integritetspolicy',
        'se:sv-se': 'sv-se/external-sharing-integritetspolicy',
        'se:en-gb': 'sv-se/external-sharing-integritetspolicy',
        'no:en-gb': 'nb-no/external-sharing-privacy-policy',
        'no:nb-no': 'nb-no/external-sharing-privacy-policy',
    },
    createCompanyFAQ: {
        'uk:en-gb': 'en-uk/merge-company-to-existing-account',
        'de:en-gb': 'en-uk/merge-company-to-existing-account',
        'se:sv': 'en-uk/merge-company-to-existing-account',
        'se:sv-se': 'en-uk/merge-company-to-existing-account',
        'se:en-gb': 'en-uk/merge-company-to-existing-account',
        'no:en-gb': 'en-uk/merge-company-to-existing-account',
        'no:nb-no': 'en-uk/merge-company-to-existing-account',
    },
};
export const appLinks = {
    signup: {
        'uk:en-gb': 'uk/signup',
        'de:en-gb': 'uk/signup',
        'se:sv': 'se/signup',
        'se:sv-se': 'se/signup',
        'se:en-gb': 'se/signup',
        'no:en-gb': 'no/signup',
        'no:nb-no': 'no/signup',
    },
};
export const externalLinks = {
    terms: {
        'uk:en-gb': 'https://miramis.co/terms',
        'de:en-gb': 'https://miramis.co/terms',
        'se:sv': 'https://miramis.co/terms',
        'se:sv-se': 'https://miramis.co/terms',
        'se:en-gb': 'https://miramis.co/terms',
        'no:en-gb': 'https://miramis.co/terms',
        'no:nb-no': 'https://miramis.co/terms',
    },
    dataProcessingAgreement: {
        'uk:en-gb': 'https://miramis.co/terms-of-service',
        'de:en-gb': 'https://miramis.co/terms-of-service',
        'se:sv': 'https://miramis.co/terms-of-service',
        'se:sv-se': 'https://miramis.co/terms-of-service',
        'se:en-gb': 'https://miramis.co/terms-of-service',
        'no:en-gb': 'https://miramis.co/terms-of-service',
        'no:nb-no': 'https://miramis.co/terms-of-service',
    },
    contact: {
        'uk:en-gb': 'https://miramis.co/support-tickets',
        'de:en-gb': 'https://miramis.co/support-tickets',
        'se:sv': 'https://miramis.co/support-tickets',
        'se:sv-se': 'https://miramis.co/support-tickets',
        'se:en-gb': 'https://miramis.co/support-tickets',
        'no:en-gb': 'https://miramis.co/support-tickets',
        'no:nb-no': 'https://miramis.co/support-tickets',
    },
    privacy: {
        'uk:en-gb': 'https://miramis.co/privacy-policy',
        'de:en-gb': 'https://miramis.co/privacy-policy',
        'se:sv': 'https://miramis.co/privacy-policy',
        'se:sv-se': 'https://miramis.co/privacy-policy',
        'se:en-gb': 'https://miramis.co/privacy-policy',
        'no:en-gb': 'https://miramis.co/privacy-policy',
        'no:nb-no': 'https://miramis.co/privacy-policy',
    },
    acceptableUsePolicy: {
        'uk:en-gb': 'https://miramis.co/acceptable-use-policy',
        'de:en-gb': 'https://miramis.co/acceptable-use-policy',
        'se:sv': 'https://miramis.co/acceptable-use-policy',
        'se:sv-se': 'https://miramis.co/acceptable-use-policy',
        'se:en-gb': 'https://miramis.co/acceptable-use-policy',
        'no:en-gb': 'https://miramis.co/acceptable-use-policy',
        'no:nb-no': 'https://miramis.co/acceptable-use-policy',
    },
    pricing: {
        'uk:en-gb': 'https://miramis.co/pricing',
        'de:en-gb': 'https://miramis.co/pricing',
        'se:sv': 'https://miramis.co/pricing',
        'se:sv-se': 'https://miramis.co/pricing',
        'se:en-gb': 'https://miramis.co/pricing',
        'no:en-gb': 'https://miramis.co/pricing',
        'no:nb-no': 'https://miramis.co/pricing',
    },
    eSigning: {
        'uk:en-gb': 'https://miramis.co/electronic-signature-software',
        'de:en-gb': 'https://miramis.co/electronic-signature-software',
        'se:sv': 'https://miramis.co/electronic-signature-software',
        'se:sv-se': 'https://miramis.co/electronic-signature-software',
        'se:en-gb': 'https://miramis.co/electronic-signature-software',
        'no:en-gb': 'https://miramis.co/electronic-signature-software',
        'no:nb-no': 'https://miramis.co/electronic-signature-software',
    },
};
function getMarket(localeCode, marketCode) {
    if (marketCode) {
        return marketCode;
    }
    switch (localeCode) {
        case 'sv':
        case 'sv-se':
            return 'se';
        case 'nb-no':
            return 'no';
        case 'en-gb':
        default:
            return 'uk';
    }
}
export function useGetLinks() {
    const localeCode = localeConfig.getActiveLocale().code;
    const marketCode = getCurrentMarket().code;
    const linkObject = {};
    Object.entries(links).forEach((link) => {
        const marketLocaleKey = `${getMarket(localeCode, marketCode)}:${localeCode}`;
        const [key, value] = link;
        const url = value[marketLocaleKey];
        linkObject[key] = `${process.env.WEBSITE_URL}/${url}`;
    });
    Object.entries(appLinks).forEach((link) => {
        const marketLocaleKey = `${getMarket(localeCode, marketCode)}:${localeCode}`;
        const [key, value] = link;
        const url = value[marketLocaleKey];
        linkObject[key] = `${process.env.APP_URL}/${url}`;
    });
    Object.entries(externalLinks).forEach((link) => {
        const marketLocaleKey = `${getMarket(localeCode, marketCode)}:${localeCode}`;
        const [key, value] = link;
        linkObject[key] = value[marketLocaleKey];
    });
    return linkObject;
}
